import { useEffect } from 'react';
import { EvaluatedCell } from 'models/interfaces/spreadsheet-types/core-types';
import {
  UseFundExchangeRateSheetProps
} from 'pages/Waterfall/SpreadsheetConfig/FundExchangeRate/useCreateFundExchangeRateSheet/UseFundExchangeRateSheet.props';

export const useFundExchangeRateSheet = ({cells, onChange, exchangeRate}: UseFundExchangeRateSheetProps) => {
  useEffect(() => {
    if (onChange && cells && exchangeRate) {
      const cell = cells.ExchangeRateSheet?.fundExchangeRate as EvaluatedCell
      if (cell ) {
        onChange(cell, exchangeRate);
      }
    }
  }, [exchangeRate, onChange, cells]);
}